import React from 'react';
import { Box } from '@mui/material';

const PolyguardLogo = ({ width = 160, height, color = 'text.primary', sx = {} }) => {
  // Logo aspect ratio based on the original PNG dimensions
  const aspectRatio = 444 / 115;
  const computedHeight = height || Math.round(width / aspectRatio);

  return (
    <Box
      component="svg"
      viewBox="0 0 444 115"
      sx={{
        width,
        height: computedHeight,
        color,
        display: 'inline-block',
        verticalAlign: 'middle',
        ...sx,
      }}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Polyguard"
    >
      {/* eslint-disable i18next/no-literal-string */}
      <text
        x="0"
        y="82"
        fontFamily="'IBM Plex Sans', sans-serif"
        fontSize="96"
        fontWeight="500"
        fill="currentColor"
      >
        Polyguard
      </text>
      {/* eslint-enable i18next/no-literal-string */}
    </Box>
  );
};

export default PolyguardLogo;
